/* eslint-disable */
import React from "react";
import "../../../assets/scss/_marker-scale.scss";
import { getScaleDetails, colorMap } from "../../../utils/reportUtils";
import MarkerProgressBar from "./MarkerScale/MarkerProgressBar";
import BoundaryLabels from "./MarkerScale/BoundaryLabels";
import tooltipIcon from "../../../assets/icons/tooltip-icon.svg";
import { buildGraphConfig, buildLegendLabels,getScaleSegments, safeRenderValue } from '../../../utils/reportUtils';
import { useMediaQuery } from "react-responsive";


const lowBoundaryTypes = ["low-normal", "low-normal-high"];
const highBoundaryTypes = [
  "normal-high",
  "low-normal-high",
  "negative-positive",
];

/**
 * MarkerScale component for displaying a marker's scale and its boundaries.
 * @returns {JSX.Element} The rendered marker scale.
 */
const MarkerScale = (props) => {
  const { value, type, code } = props;
  const showLowBoundary = lowBoundaryTypes.includes(type);
  const showHighBoundary = highBoundaryTypes.includes(type);
  const isBoolMarker = type === "negative-positive";
  const normalBoundaryLabel = isBoolMarker ? "Not detected" : "Normal";
  let highBoundaryLabel = isBoolMarker ? "Detected" : "High";
  const scaleSegments = getScaleSegments(code, value);
  const { ranges } = buildGraphConfig(props);
  const isB12 =code === "B12A";
  const legendLabels = buildLegendLabels(ranges,true, isB12);
  const isMobile = useMediaQuery({ maxWidth: 767 });

  if (String(value).toLowerCase() === "unconfirmed reactive") {
    highBoundaryLabel = "Unconfirmed Reactive";
  }

  const { barSize, pointerPosition, leftBarSize } = getScaleDetails(props);

  const lowerBoundary = parseFloat(props.lower_boundary);
  const upperBoundary = parseFloat(props.upper_boundary);
  const resultLabel = props.result
    ? props.result.replaceAll("_", " ").replace(/^./, (str) => str.toUpperCase())
    : "";
  const isManual = props.decision_type?.includes("manual");

  return (
    <div
      className="markerScale__container"
      data-testid="marker-scale-container"
    >
        <>
          {/* Pointer indicator */}
          <div
            className="markerScale__pointer"
            data-testid="marker-scale-pointer"
            style={{ 
              left: `${scaleSegments?.pointerPosition ?? pointerPosition}%`,
              top:  isManual
                    ? (isMobile ? "12%" : "21%")
                    : (isMobile ? "10%" : "16%"),}}
          >
            <img src={tooltipIcon} alt="" aria-hidden="true" />
          </div>
    
          {/* Boundary labels */}
          <BoundaryLabels
            showLowBoundary={showLowBoundary}
            showHighBoundary={showHighBoundary}
            leftBarSize={leftBarSize}
            barSize={barSize}
            normalBoundaryLabel={normalBoundaryLabel}
            highBoundaryLabel={highBoundaryLabel}
            decision_type={props.decision_type}
            type={props.type}
            lower_boundary={lowerBoundary}
            upper_boundary={upperBoundary}
            boundary={props.boundary}
            code={code}
            scaleSegments={scaleSegments}
          />
    
          {/* Progress bar */}
          <MarkerProgressBar
            leftBarSize={leftBarSize}
            barSize={barSize}
            showLowBoundary={showLowBoundary}
            showHighBoundary={showHighBoundary}
            value={value}
            code={code}
            scaleSegments={scaleSegments}
            decision_type={props.decision_type}
          />

          <div className="d-flex flex-column justify-content-center">
            {props?.type !== "negative-positive" && (
              <>
                <div className={`d-flex justify-content-center align-items-center mt-2 ${isMobile && "flex-column"}`}>
                  <div className={`markerCard__value ageo-semibold ${(isMobile || props.isGraph) ? "fs-22" : "fs-17"}`}>
                    {safeRenderValue(Number.parseFloat(value).toFixed(2))}{" "}
                    {props?.units && (
                      <span className={`markerCard__unit ageo-medium ${(isMobile || props.isGraph) ? "fs-18" : "fs-13"}`}>
                        {"("}
                        {safeRenderValue(props?.units)}
                        {")"}
                      </span>
                    )}
                  </div>
                  <span
                    className={`markerCard__status-badge markerCard__status-badge--${props.result}`}
                  >
                    {resultLabel}
                  </span>
                </div>
                {props.decision_type.includes("manual") ? null :
                  <div className="mg__legend">
                    {ranges.map((r, i) => (
                      <div key={r.key} className="mg__legend-item">
                        <div
                          className="mg__legend-dot"
                          style={{ backgroundColor: r.dotColor }}
                        />
                        <span className="mg__legend-label">
                          <span className="label-prefix">{legendLabels[i].prefix}</span>
                          <span className="label-suffix">{legendLabels[i].suffix}</span>
                        </span>
                      </div>
                    ))}
                  </div>
                }
              </>
            )}
          </div>
        </>
    </div>
  );
};

export default MarkerScale;
